import './S_Link.scss';
import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { MouseEvent, PropsWithChildren, ReactElement } from 'react';
import { useHistory } from 'react-router-dom';

interface IProps {
  to?: string;
  onClick?: () => void;
  disabled?: boolean;
  title?: string;
  className?: string;
  color: 'text' | 'anchor';
}

export const S_Link = observer((props: PropsWithChildren<IProps>): ReactElement => {
  const history = useHistory();

  const handleLinkClick = (e: MouseEvent): void => {
    e.preventDefault();
    if (!props.disabled) {
      if (props.to) {
        history.push(props.to);
      } else if (props.onClick) {
        props.onClick();
      }
    }
  };

  return (
    <a
      className={classNames('s-link', props.className, props.color, { disabled: props.disabled })}
      title={props.title}
      onClick={handleLinkClick}
    >
      {props.children}
    </a>
  );
});
